import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import StoreUtil from "../store.util.js";

const state = {
  boardList: StoreUtil.state(),
};

const inventoryModule = {
  state,
  mutations,
  actions,
  getters,
};

export default inventoryModule;
